// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Recommendation from '../../../components/analytics/pptx/Recommendation';
// css
import '../../../styles/components/analytics/Recommendations.scss';


class RecommendationsOne extends Component {
  constructor(props) {
    super(props);
  }

  renderSortedAreas(areasWithGoals) {
    const getCount = goals => {
      let count = 0;
      goals.forEach(goal => {
        if (goal.isKeyGoal === true && goal.groups.length > 0) {
          count += 1;
        }
      });
      return count;
    };

    areasWithGoals = areasWithGoals.sort((area1, area2) => {
      return getCount(area2.goals) - getCount(area1.goals);
    });

    const columnOne = [];
    const columnTwo = [];

    for (let i = 0; i < areasWithGoals.length; i += 2) {
      columnOne.push(<Recommendation areaWithGoals={areasWithGoals[i]} key={i} />);
      if (i + 1 < areasWithGoals.length) {
        columnTwo.push(<Recommendation areaWithGoals={areasWithGoals[i + 1]} key={i + 1} />);
      }
    }

    return (
      <div className='row'>
        <div className='col-xs-6'>{columnOne}</div>
        <div className='col-xs-6'>{columnTwo}</div>
      </div>
    );
  }

  render() {
    const areasWithGoals = this.props.adoptionGoalsWithAreas.areasWithGoals;

    return (
      <div className='analytics__recommendations' id={this.props.pptxTarget}>
        {this.renderSortedAreas(areasWithGoals)}
      </div>
    );
  }
}

RecommendationsOne.propTypes = {
  adoptionGoalsWithAreas: PropTypes.object,
  pptxTarget: PropTypes.string
};

export default RecommendationsOne;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/Recommendations.js